<!--The content below is only a placeholder and can be replaced.-->
<!-- <mat-toolbar> My App</mat-toolbar> -->

<!-- TOOLBAR -->
<mat-toolbar class="mat-toolbar mat-elevation-z6"> 
    <mat-toolbar-row >
      <img width="50px" src="./../assets/imagenes/icono2.png">
      <span>Amicare</span>
      <div class="spacer"></div>
      <button class="signOut" (click)="signOut()">
          <mat-icon>exit_to_app</mat-icon>
      </button>
      <!-- <amplify-sign-out 
        button-text="Exit">
      </amplify-sign-out> -->
    </mat-toolbar-row> 
  </mat-toolbar>
  
  <div class="content">
    
    <div class="divListUser" *ngIf="(flagUsuarios)">

      <p class="title">LISTADO DE DISPOSITIVOS INSTALADOS</p>
      <ul class="listaUser">
        <li *ngFor="let array_tab_usuarios of this.array_tab_usuarios;">
          <!-- <div [routerLink]="['/main-user', array_tab_usuarios.nombre]" [routerLinkActive]="['actived']"> -->
            <div class="divUser" (click)="loadMainUser(array_tab_usuarios)">
                <mat-icon class="icon" aria-label="User">account_circle</mat-icon>
                <a>{{array_tab_usuarios.nombre + " " + array_tab_usuarios.apellidos + " - " + array_tab_usuarios.useridCETEM}}</a>
            </div>
            <div class="divDisp">
                <!-- <p>disp1</p> -->
                <div>
                    <mat-icon aria-label="memory">memory</mat-icon>
                    {{array_tab_usuarios.disp1}}
                    <mat-icon *ngIf="(array_tab_usuarios.estadoDisp1)" class="iconON" aria-label="sensors">sensors</mat-icon>
                    <mat-icon *ngIf="(!array_tab_usuarios.estadoDisp1)" class="iconOFF" aria-label="sensors">sensors</mat-icon>
                    - Cama
                </div>
                <div>
                    <mat-icon aria-label="memory">memory</mat-icon>
                    {{array_tab_usuarios.disp2}}
                    <mat-icon *ngIf="(array_tab_usuarios.estadoDisp2)"  class="iconON" aria-label="sensors">sensors</mat-icon>
                    <mat-icon *ngIf="(!array_tab_usuarios.estadoDisp2)"  class="iconOFF" aria-label="sensors">sensors</mat-icon>
                    - Sillón
                </div>
                <div>
                  <mat-icon aria-label="memory">memory</mat-icon>
                  {{array_tab_usuarios.disp3}}
                  <mat-icon *ngIf="(array_tab_usuarios.estadoDisp3)"  class="iconON" aria-label="sensors">sensors</mat-icon>
                  <mat-icon *ngIf="(!array_tab_usuarios.estadoDisp3)"  class="iconOFF" aria-label="sensors">sensors</mat-icon>
                  - Frigorífico
              </div>


            </div>
        </li>
      </ul>

    </div>
    <button class="buttonActualizar" *ngIf="(flagUsuarios)" mat-raised-button color="accent" (click)="actualizar()">Actualizar</button>
</div>

<h2 class="spinner" *ngIf="(!flagUsuarios)">{{bufferValue}} / {{valueProgress}}</h2>
<mat-spinner class="spinner" *ngIf="(!flagUsuarios)"></mat-spinner>


   
<footer class="footer mat-elevation-z4">
    <img class="imagencetem " src="./../assets/imagenes/developed_by_cetem.png"/>
    &copy;
</footer>
  
